module.exports = __webpack_public_path__ + "static/fonts/Oxanium-Light.8a0e5c84.ttf";